module.exports = __webpack_public_path__ + "static/img/clientInterfaceBg.ca17127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clientInterfaceBg.jpg
// module id = 522i
// module chunks = 1